import type { SimpleSearchConfig } from '@/shared/ui/search/SimpleSearch/types/search.types';

/**
 * SimpleSearch 설정 (플래너 목록용)
 */
export const plannerSimpleSearchConfig: SimpleSearchConfig = {
  fields: [
    { name: 'name', label: '이름' },
    { name: 'phone', label: '연락처' },
  ],
  placeholder: '이름, 연락처로 검색',
  enableFieldSelect: true,
};
